import React from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { customTableColumns } from './CustomTableColumns';
import CustomTable from '../../../../../components/CustomTable';
import { getSurveyTemplateQuestions, deleteSurveyQuestionTemplate, updateSurveyQuestionTemplateSecuence, resetQuestion } from '../../../../../redux/survey/surver_template/questions/actions';
import FilterButtons from '../../../../../components/filter_buttons/FilterButtons';
import { getFilterButtonsConfig } from './filterButtonsConfig';
import QuestionForm from './QuestionForm';


const QuestionsList = ({surveyId}) => {
  const [show, setShow] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [question, setQuestion] = React.useState(null);
  const dispatch = useDispatch();
  const {surveyTemplateQuestions,
         isLoadingQuestions,
         error} = useSelector(state => state.surveyTemplateQuestions);

  const getQuestions = () => dispatch(getSurveyTemplateQuestions({id: surveyId}));

  React.useEffect(() => {
    getQuestions();
  }, []);

  const onDelete = (id) => {
    if (window.confirm('¿Estás seguro de eliminar la pregunta?')) {
      dispatch(deleteSurveyQuestionTemplate(id));
    }
  }

  const onEdit = (question) => {
    setShow(true);
    setIsEdit(true);
    setQuestion(question);
  }

  const onAdd = () => {
    setShow(true);
    setIsEdit(false);
    setQuestion(null);
    dispatch(resetQuestion());
  }

  const handleSortFunc = (rows) => {
    const data = rows.map((row, index) => {
      return {
        id: row.original.id,
        secuence: index + 1
      }
    });
    dispatch(updateSurveyQuestionTemplateSecuence({data}));
  }

  const columns = customTableColumns(onEdit, onDelete);
  const filterButtonsConfig = getFilterButtonsConfig(onAdd, getQuestions);

  return (
    <>
      <div className="my-3">
        <FilterButtons buttons={filterButtonsConfig} justifyContent="justify-content-end" />
      </div>
      {
        error && 
        <Alert variant="danger" className="my-3">
          {error}
        </Alert>
      }
      <CustomTable 
        columns={columns}
        data={surveyTemplateQuestions}
        isLoadingData={isLoadingQuestions}
        isErrorToLoadData={!!error}
        maySortableRows={true}
        handleSortFunc={handleSortFunc} />
      <QuestionForm 
        show={show} 
        setShow={setShow}
        isEdit={isEdit}
        question={question} />
    </>
  )
}

export default QuestionsList;